import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from "@material-ui/core";
import useStyles from "../css/styles";
import React from "react";
import { useEffect, useState } from "react";
import OtpInput from 'react-otp-input';
import { formatphone, GetOTP, SendOTP, InsertPELogs } from "../api"; //FB 4960
import globalsettings from "../../../config";


//Update Log
// FB 4867 DK   12/27/2021    Added screen for verification
// FB 4960 BR    07/03/2022   Logging all actions on PE
// FB 9664 SK   11/19/2024    verify button not properly pulling all numbers from verification code


export default function OTPModal(props: any) {
    const [OTP, setOTP] = useState("");
    const validOTPlength = 4;
    const styles = useStyles();
    const [showModeSelection, setShowModeSelection] = useState(true);
    const [showOTPGrid, setShowOTPGrid] = useState(false);
    const [sendEmail, setSendEmail] = useState(0);
    const [sendText, setSendText] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(2);
    const [isOTPErrored, setIsOTPErrored] = useState(false);
    const [isTimeOut, setIsTimeOut] = useState(false);
    const [isCodeResent, setIsCodeResent] = useState(false);
    var JSAlert = require("js-alert");
    const handleOTPChange = (value: any) => {
        setOTP(value);
        setIsOTPErrored(false);
    }
    //FB 9664 - Begin
    const handleOTPPaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
        const pastedValue = event.clipboardData.getData("Text").trim();
        if (/^\d+$/.test(pastedValue) && pastedValue.length === validOTPlength) {
            setOTP(pastedValue);
            setIsOTPErrored(false);
        } else {
            setIsOTPErrored(true);
        }
    };
    //FB 9664 - End
    const handleSendOTP = async () => {
        await SendOTP(props.appointment_n, false, sendEmail, sendText)
            .then((data) => {
                setShowModeSelection(false);
                setShowOTPGrid(true);
                setMinutes(6);
                setSeconds(0);
            })
            .catch((error) => error);
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Clicked on Send code - OTP modal");
        //FB 4960 End
    }
    const handleReSendOTP = async () => {
        await SendOTP(props.appointment_n, false, sendEmail, sendText)
            .then((data) => {
                setIsCodeResent(true);
                setIsOTPErrored(false);
                setIsTimeOut(false);
                setMinutes(6);
                JSAlert.alert("Verification code re-sent successfully", null, JSAlert.Icons.Success);
            })
            .catch((error) => error);
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Clicked on Resend code - OTP modal");
        //FB 4960 End
    }

    const handleEmailCheckbox = (e: any) => {
        if (e.target.checked) {
            setSendEmail(1);
            //FB 4960 Start
            InsertPELogs(globalsettings.clientIp, "Checked on Email - OTP modal");
            //FB 4960 End
        }
        else {
            setSendEmail(0);
            //FB 4960 Start
            InsertPELogs(globalsettings.clientIp, "UnChecked on Email - OTP modal");
            //FB 4960 End
        }
    }

    const handlePhoneCheckbox = (e: any) => {
        if (e.target.checked) {
            setSendText(1);
            //FB 4960 Start
            InsertPELogs(globalsettings.clientIp, "Checked on Phone - OTP modal");
            //FB 4960 End
        }
        else {
            setSendText(0);
            //FB 4960 Start
            InsertPELogs(globalsettings.clientIp, "Unchecked on Phone - OTP modal");
            //FB 4960 End
        }
    }
    const handleVerifyClick = async () => {
        await GetOTP(props.appointment_n, false)
            .then((data) => {
                if (data === Number(OTP)) {
                    sessionStorage.setItem("IsPatientVerified", "Yes");
                    var encodedAppt_n = Buffer.from(props.appointment_n).toString('base64');
                    props.onCallback(false);
                    if (props.selectedStep === "HealthForms") {
                        const IntakeURL = globalsettings.emrAPI + "patient_intake/note_add_edit.asp?app_n=" + encodedAppt_n;
                        window.open(IntakeURL);
                    }
                    else if (props.selectedStep === "FileUpload") {
                        const Uploadurl = window.location.origin + "/upload/" + encodedAppt_n;
                        window.open(Uploadurl);
                        //window.open("http://192.168.30.246:20000/upload/" + props.appointment_n);
                    }
                }
                else {
                    setOTP("");
                    setIsOTPErrored(true);
                }
            })
            .catch((error) => error);
        //FB 4960 Start
        InsertPELogs(globalsettings.clientIp, "Click on Verify");
        //FB 4960 End
    }

    function updateTime() {
        if (minutes == 0 && seconds == 0) {
            setIsTimeOut(true);
            setIsOTPErrored(false);
        }
        else {
            if (seconds == 0) {
                setMinutes(minutes => minutes - 1);
                setSeconds(59);
            } else {
                setSeconds(seconds => seconds - 1);
            }
        }
    }

    useEffect(() => {
        const token = setTimeout(updateTime, 1000)

        return function cleanUp() {
            clearTimeout(token);
        }
    }, [minutes, seconds])

    return (
        <div>
            <Grid container spacing={2} style={{ display: showModeSelection ? "flex" : "none", alignContent: "center", justifyContent: "center" }} >
                <Grid item xs={12}>
                    A four digit code will be sent to the below selected option(s) for verification
                </Grid>
                <Grid item xs={12} style={{ display: props.patientContact.email.length > 0 ? "flex" : "none" }}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox onChange={handleEmailCheckbox}
                            style={{ color: "#18a2b8" }} />} label={props.patientContact.email.replace(/^(.{1})[^@]+/, "$1******")} />
                    </FormGroup>
                </Grid>
                <Grid item xs={12} style={{ display: props.patientContact.cellPhone.length > 0 ? "flex" : "none" }}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox onChange={handlePhoneCheckbox}
                            style={{ color: "#18a2b8" }} />} label={formatphone(props.patientContact.cellPhone).props.children[1].replace(/^(.{0})[^-]+/, "$1******")} />
                    </FormGroup>
                </Grid>
                <Grid item xs={6}>
                    <Button
                        className={styles.navigationButton}
                        onClick={handleSendOTP}
                        style={{ display: sendEmail > 0 || sendText > 0 ? "flex" : "none" }}
                        fullWidth
                    >
                        Send Code
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={2} style={{ display: showOTPGrid ? "flex" : "none" }}>
                <Grid item xs={12}>
                    <Typography>Please enter your code</Typography>
                </Grid>
                {/* FB 9664 */}
                <Grid  onPaste={handleOTPPaste} item xs={12} style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                    <OtpInput
                        value={OTP}
                        onChange={handleOTPChange}
                        numInputs={validOTPlength}
                        separator={<span>-</span>}
                        isInputNum={true}
                        inputStyle={styles.otp}
                        shouldAutoFocus
                        hasErrored={isOTPErrored}
                        errorStyle={styles.otpError} 
                    />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                    <Typography color="error" style={{ display: isOTPErrored ? "flex" : "none" }}>
                        Entered code is invalid/expired.
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                    <Typography style={{ display: !isTimeOut ? "flex" : "none" }}>
                        {minutes + "m " + seconds + "s left"}
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                    <Button
                        className={styles.navigationButton}
                        style={{ display: isTimeOut ? "flex" : "none", marginLeft: 5 }}
                        onClick={handleReSendOTP}
                    >
                        Resend
                    </Button>

                    <Button
                        className={OTP.length < validOTPlength ? styles.disabledButton : styles.navigationButton}
                        disabled={(OTP.length < validOTPlength) ? true : false}
                        onClick={handleVerifyClick}
                        style={{ marginLeft: 5 }}
                    >
                        Verify
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
}